import UpdateButton from "../../../shared/UpdateButton/UpdateButton";
import {USB_MODEM_LOCATION_LABELS, UsbModemProps} from "../SystemSettings.model";
import {useEffect, useState} from "react";
import {SystemSettingsApi} from "../../../../services/SystemSettings.api";
import StatusControl from "../../../shared/StatusControl/StatusControl";
import {Input, InputGroup, toaster} from "rsuite";
import moment from "moment-timezone";
import {TfiSaveIcon} from "../../../../models/Icons.model";
import NotificationFactory from "../../../../shared/Notifications";
import {GetEspConnections_GetEspConnectionsResponse, UsbModemLocation} from "../../../../api";

const UsbModem = ({loading, deviceId}: UsbModemProps) => {
  const [usbModemParams, setUsbModemParams] = useState<GetEspConnections_GetEspConnectionsResponse | null>(null);
  const usbModemLocationOptions = Object.entries(USB_MODEM_LOCATION_LABELS) as Array<[UsbModemLocation, string]>;

  useEffect(() => {
    getParams().then()
  }, [deviceId]);

  const getParams = async () => {
    try {
      const response = await SystemSettingsApi.getUsbModemParams(deviceId)

      setUsbModemParams(response)
    } catch (err) {
      toaster.push(
        NotificationFactory.error('Не удалось получить параметры'),
        {placement: 'topEnd'}
      );
      console.log(err)
    }
  }

  const updateUsbModemLocation   = async () => {
    try {
      const usbModemLocation = usbModemParams?.usbModemLocation;
      if (!usbModemLocation) return;

      const result  = await SystemSettingsApi.updateUsbModemLocation(deviceId, usbModemLocation);
      if (result) {
        toaster.push(
          NotificationFactory.success(`Успешно обновлено`),
          {placement: 'topEnd'}
        );
        await getParams();
      }
    } catch (err) {
      toaster.push(
        NotificationFactory.error(),
        {placement: 'topEnd'}
      );
      console.log(err)
    }
  }


  return (
    <div className="fieldset-wrapper mb-2">
    <div className="legend-title main-legend-title">Работа USB модема</div>
    <section className="secondary-clock">
      <div className="row p-2">
        <div className="col-12 d-flex justify-content-end gap-2">
          <UpdateButton loading={loading} onRefresh={getParams}/>
        </div>
      </div>
      <div className="row p-2 pt-0">
        <div className="col-md-6">
          <div className="row" style={{marginTop: 12}}>
            <div className="col-md-6 d-flex align-items-center">
              <StatusControl status={usbModemParams?.bluetoothAlwaysOn ? "online" : 'offline'}></StatusControl>
              Вкл/Выкл Bluetooth
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <StatusControl status={usbModemParams?.bluetoothState ? "online" : 'offline'}></StatusControl>
              Bluetooth state
            </div>
          </div>
          <InputGroup className="mt-2">
            <InputGroup.Addon>APN</InputGroup.Addon>
            <Input value={usbModemParams?.apn ?? ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup className="mt-2">
            <InputGroup.Addon>IMEI</InputGroup.Addon>
            <Input value={usbModemParams?.imei ?? ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup className="mt-2">
            <InputGroup.Addon>Время перезагрузки модема</InputGroup.Addon>
            <Input value={usbModemParams?.lastModemReboot ? moment(usbModemParams.lastModemReboot).format('DD.MM.yyyy HH:mm:ss') : ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup className="mt-2">
            <InputGroup.Addon>Логин</InputGroup.Addon>
            <Input value={usbModemParams?.login ?? ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup className="mt-2">
            <InputGroup.Addon>Пароль</InputGroup.Addon>
            <Input value={usbModemParams?.password ?? ""} type="text" readOnly/>
          </InputGroup>
        </div>
        <div className="col-md-6">
          <InputGroup className="mt-2">
            <InputGroup.Addon>Адрес текущей прошивки</InputGroup.Addon>
            <Input value={usbModemParams?.partition ?? ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup className="mt-2">
            <InputGroup.Addon>Тип соединения</InputGroup.Addon>
            <Input value={usbModemParams?.serverConnection ?? ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup className="mt-2">
            <InputGroup.Addon>Скорость UART 1</InputGroup.Addon>
            <Input value={usbModemParams?.uart1Speed ?? ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup className="mt-2">
            <InputGroup.Addon>Скорость UART 2</InputGroup.Addon>
            <Input value={usbModemParams?.uart2Speed ?? ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup className="mt-2">
            <InputGroup.Addon>Режим Wi-Fi</InputGroup.Addon>
            <Input value={usbModemParams?.wifiMode ?? ""} type="text" readOnly/>
          </InputGroup>
          <InputGroup style={{padding: 0}} className="mt-2">
            <InputGroup.Addon>Места подключения модема</InputGroup.Addon>
            <div style={{width: "100%"}}>
              <select
                className="form-select"
                style={{borderRadius: 0}}
                value={usbModemParams?.usbModemLocation || ""}
                onChange={(event) => {
                  const value = event.target.value;
                  setUsbModemParams((prev) => prev ? {
                    ...prev,
                    usbModemLocation: value as UsbModemLocation
                  } : prev);
                }}
              >
                <option value=""></option>
                {usbModemLocationOptions.map(([key, label]) => (
                  <option key={key} value={key}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            <InputGroup.Button
              style={{cursor: 'pointer'}}
              onClick={updateUsbModemLocation}
              title="Сохранить"
            >
              <TfiSaveIcon/>
            </InputGroup.Button>
          </InputGroup>
        </div>
      </div>
    </section>
    </div>
  )
}

export default UsbModem;
